// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3595":"cb93e83f","3974":"cb93e83f","6071":"cb93e83f"}[chunkId] + ".chunk.css";
};